// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"31d6cfe0","281":"204b45db","758":"812999c4"}[chunkId] + ".chunk.css";
};